module.exports = __webpack_public_path__ + "img/area-limit-btn.c3ceebc6.png";